import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import SubscribedPackageCard from '../../components/SubscribedPackageCard';
import Headerpackages from '../../components/Header/Headerpackages';
import { checkSubscription } from '../../components/APICall/Api';

const SubscribedPackageDetails = () => {
  const { apiService } = useParams();
  const [subscriptionData, setSubscriptionData] = useState(null);

  // Using async function inside useEffect
  useEffect(() => {
    const fetchSubscriptionData = async () => {
      try {
        const msisdn = JSON.parse(sessionStorage.getItem("msisdn"));
        const result = await checkSubscription(apiService, msisdn);
        
        // Check if the result has the expected structure
        if (result && result.payLoad) {
          setSubscriptionData(result.payLoad);
        } 
      } catch (err) {
        console.error("Error fetching subscription data:", err);
      } 
    };

    fetchSubscriptionData();
  }, [apiService]);

  return (
    <>
        <Headerpackages title={`<span style="color:#8cc63e; font-weight:600;">Subscription</span> Details`} />

  
      {subscriptionData && (
        <SubscribedPackageCard subscriptionData={subscriptionData} />
      )}
    </>
  );
};

export default SubscribedPackageDetails;
